// react-srcdoc.ts
// Bygger ett srcdoc-FRAGMENT (inte fullständigt dokument) som SandboxFrame wrapar
// med CSP + felbrygga. Laddar React/ReactDOM/Babel från whitelistade CDN:er och
// kör modellens komponentkod i en text/babel-script. Konventionen (styrd via prompten)
// är att komponenten heter `App`; vi monterar <App/>. En ledande `export default`
// tas bort så koden kör i babel-scriptets globala scope.
// Versions are PINNED deliberately: the unpinned "@babel/standalone/babel.min.js"
// (latest) throws "Cannot use import statement outside a module" and refuses to
// transform the component. 7.23.5 works. React/ReactDOM are pinned to 18.2.0 for
// the same determinism. Tailwind uses the classic Play CDN (cdn.tailwindcss.com) —
// the "@tailwindcss/browser@4" ESM build fails when loaded as a classic script.
const REACT_CDN = "https://unpkg.com/react@18.2.0/umd/react.production.min.js"
const REACT_DOM_CDN = "https://unpkg.com/react-dom@18.2.0/umd/react-dom.production.min.js"
const BABEL_CDN = "https://unpkg.com/@babel/standalone@7.23.5/babel.min.js"
const TAILWIND_CDN = "https://cdn.tailwindcss.com"

export function stripExportDefault(code: string): string {
  // "export default function App" -> "function App"; "export default App" -> "App"
  return code.replace(/export\s+default\s+/g, "")
}

export function buildReactSrcDoc(code: string): string {
  // Escape any `</script` in the model's code so it can't prematurely close the
  // text/babel <script> block below (which would truncate/corrupt the render).
  // The HTML parser closes the tag on the raw `</script` token regardless of JS
  // string context, so this must happen before interpolation.
  const componentCode = stripExportDefault(code).replace(/<\/script/gi, "<\\/script")
  return `<script src="${REACT_CDN}" crossorigin></script>
<script src="${REACT_DOM_CDN}" crossorigin></script>
<script src="${BABEL_CDN}"></script>
<script src="${TAILWIND_CDN}"></script>
<div id="root"></div>
<script type="text/babel" data-presets="react,typescript">
${componentCode}
const __artifactRoot = ReactDOM.createRoot(document.getElementById("root"));
__artifactRoot.render(React.createElement(App));
</script>`
}
